<div class="flex justify-content-center align-items-center">
  <div class="flip-card p-2" [ngClass]="flipForward ? 'forward' : 'backward'">
    <div class="flip-card-inner">
      <!-- image de face -->
      <div class="flip-card-front">
        <div class="image__container relative">
          <p class="text-xl font-bold text-indigo-800	"> {{ mentalCard.number }} </p>
        </div>
      </div>
      <!-- imge de derriere -->
      <div class="flip-card-back">
        <img [src]="backImageNameUrl">
      </div>
    </div>
  </div>
  <!-- Contient l'opérateur arithmetique -->
  <ng-content></ng-content>
</div>
